// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__Xw_Ay","left":"Sidebar_left__Fi7NA","right":"Sidebar_right__Gqjxa"};